import React from 'react';
import './SocialMediaGroup.scss';

import { PropTypes } from 'prop-types';
import { ReactComponent as Facebook } from '../../svg/flaticon/socialmedia/021-facebook.svg';
import { ReactComponent as Instagram } from '../../svg/flaticon/socialmedia/025-instagram.svg';
import { ReactComponent as Github } from '../../svg/flaticon/socialmedia/038-github.svg';
import { ReactComponent as Linkedin } from '../../svg/flaticon/socialmedia/045-linkedin.svg';

const classNames = require('classnames');

const Icon = ({ url, icon }) => (
  <a href={url} target="_blank" rel="noopener noreferrer">
    {icon}
  </a>
);

Icon.propTypes = {
  url: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

const SocialMediaGroup = ({ loading, gridGap, height }) => {
  const smClasses = classNames({
    'social-media': true,
    loading,
  });

  const parentStyle = {
    gridGap,
  };

  const iconStyle = {
    height,
  };

  return (
    <div style={parentStyle} className={smClasses}>
      <Icon
        url="https://www.facebook.com/kevyn.hale"
        icon={<Facebook style={iconStyle} />}
      />
      <Icon
        url="https://www.instagram.com/kevynhale/"
        icon={<Instagram style={iconStyle} />}
      />
      <Icon
        url="https://github.com/kevynhale"
        icon={<Github style={iconStyle} />}
      />
      <Icon
        url="https://www.linkedin.com/in/kevyn-hale-4285698a/"
        icon={<Linkedin style={iconStyle} />}
      />
    </div>
  );
};

SocialMediaGroup.propTypes = {
  loading: PropTypes.bool,
  height: PropTypes.string,
  gridGap: PropTypes.string,
};

SocialMediaGroup.defaultProps = {
  height: '25px',
  gridGap: '15px',
  loading: false,
};

export default SocialMediaGroup;
